import script from "./MindCollect.vue?vue&type=script&setup=true&lang=js"
export * from "./MindCollect.vue?vue&type=script&setup=true&lang=js"

import "./MindCollect.vue?vue&type=style&index=0&id=a5e7fe3e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5e7fe3e"]])

export default __exports__